/* istanbul ignore file */
import React from 'react';
import { Badge, type BadgeProps } from 'framework/ui/mui-builder';

const ActiveProbationBadge = (props: BadgeProps) => {
  return (
    <Badge color="success" {...props}>
      Probation
    </Badge>
  );
};

export default ActiveProbationBadge;
